import axios from "axios";
import { API_URL, APP_TYPE } from '../config/Config'
import Cookies from "js-cookie";
import { jwtDecode } from "jwt-decode";
import axiosInstance from './AxiosInstance';
// axios.defaults.headers.common['Content-Type'] = 'application/json';

class AuthenticationService {
    constructor() {
        this.endpoint = `/api/auth`
    }


    async login() {
        try {
            const response = await axiosInstance.get(`${this.endpoint}/userinfo`);

            // debugger;

            if (response.data && response.data.success) {
                if (APP_TYPE == "PoliticalParty") {
                    var candidate = response.data?.candidate
                    if (candidate?.isNationalDelimitation) {
                        response.data.candidate.constituencyID = response?.data?.candidate?.delimitationID;
                        response.data.candidate.constituencyCode = response?.data?.candidate?.delimitationCode;
                        response.data.candidate.constituencyName = response?.data?.candidate?.delimitationName;
                    } else {
                        try {
                            response.data.candidate.constituencyID = response?.data?.candidate?.councilID;
                            response.data.candidate.constituencyCode = response?.data?.candidate?.councilCode;
                            response.data.candidate.constituencyName = response?.data?.candidate?.councilName;


                            response.data.candidate.votingDistrictID = response?.data?.candidate?.delimitationID;
                            response.data.candidate.votingDistrictCode = response?.data?.candidate?.delimitationID;
                            response.data.candidate.votingDistrictName = response?.data?.candidate?.delimitationName;
                        } catch (error) {

                        }

                    }

                }

                const delimitation = APP_TYPE == "PoliticalParty" ? [response.data.candidate] : response.data.delimitations;
                localStorage.setItem('central-site-delimitation', JSON.stringify(delimitation));
                localStorage.setItem("central-site-user", JSON.stringify({
                    userID: response.data.userID,
                    username: response.data.username,
                    email: response.data.username,
                    groups: response.data.groups
                }));
                localStorage.setItem("central-site-date",
                    new Date(response.data.system.systemDateTime).toISOString()
                );

                return { status: true, groups: response.data.groups, data: response.data };
            }
        } catch (error) {
            console.log(error);
        }

        return { status: false, groups: [] };
    };

    async refreshToken() {
        // if (localStorage.getItem("token")) {
        //     var tokens = JSON.parse(localStorage.getItem("token"));

        //     try {
        //         console.log("refresh token...")
        //         let response = await this.api.post('/refreshtoken', {
        //             "refreshToken": tokens.refreshToken,
        //         });

        //         console.log("refresh token done:" + response.data.success)

        //         if (response.data.success) {
        //             localStorage.setItem("isAuthenticated", true);
        //             localStorage.setItem("token", JSON.stringify(response.data.token));
        //             return true;
        //         }

        //     } catch (error) {

        //     }
        // }

        return false;
    }

    signOut() {
        Cookies.set("LoggedIn", false);
        localStorage.clear();
        window.location.href = '/login';
    }

    getCurrentUser() {
        return JSON.parse(localStorage.getItem("central-site-user"));
    }

    getUserDelimitation() { //Used for political party
        var delimitation = [];
        if (localStorage.getItem('central-site-delimitation') !== null) {
            delimitation = JSON.parse(localStorage.getItem('central-site-delimitation'));
        }
        return delimitation
    }
    getDelimitation() {
        const districts = [];
        if (localStorage.getItem('central-site-delimitation') !== null) {
            const delimitation = JSON.parse(localStorage.getItem('central-site-delimitation'));
            delimitation.forEach(item => {
                // Find if the district already exists
                let district = districts.find(d => d.id === item.districtID);
                if (!district) {
                    // If not, add a new district
                    district = {
                        code: item.districtCode,
                        id: item.districtID,
                        name: `${item.districtCode} - ${item.districtName}`,
                        constituencies: []
                    };
                    districts.push(district);
                }

                // Add the constituency to the district
                if (item.constituencyID) {
                    district.constituencies.push({
                        id: item.constituencyID,
                        name: `${item.constituencyCode} - ${item.constituencyName}`,
                        code: item.constituencyCode,
                    });
                }

            });
        }
        return districts;
    }

    get AccesToken() {
        var result = null;
        if (localStorage.getItem("token")) {
            result = JSON.parse(localStorage.getItem("token"));
        }

        return result;
    }

    get DeviceID() {
        var result = null;
        if (localStorage.getItem("deviceID")) {
            result = JSON.parse(localStorage.getItem("deviceID"));
        }

        return result;
    }

    get User() {
        return JSON.parse(localStorage.getItem("central-site-user"));
    }

    get RefreshToken() {
        var result = null;
        if (localStorage.getItem("token")) {
            var tokens = JSON.parse(localStorage.getItem("token"));
            result = tokens.refreshToken;
        }

        return result;
    }

    get Modules() {
        const moduleMap = new Map();

        this.User.groups.forEach(group => {
            group.modules.forEach(module => {
                if (!moduleMap.has(module.moduleID)) {
                    // Add module to the map if not already added
                    moduleMap.set(module.moduleID, {
                        moduleID: module.moduleID,
                        name: module.name,
                        actions: module.actions
                    });
                }
            });
        });

        return Array.from(moduleMap.values());
    }

    get TokenExpired() {
        var result = true;

        if (localStorage.getItem("token")) {
            try {
                var tokens = JSON.parse(localStorage.getItem("token"));
                const decodedToken = jwtDecode(tokens.idToken);
                const currentTime = Date.now() / 1000;
                return decodedToken.exp < currentTime;
            } catch (error) {
                console.error('Error decoding token:', error);
            }
        }

        return result;
    }
    getDelimitation1() {
        var districts = [];
        var constituencies = [];

        if (localStorage.getItem('central-site-delimitation') !== null) {
            const delimitation = JSON.parse(localStorage.getItem('central-site-delimitation'));
            delimitation.forEach(delimitation => {
                districts.push({
                    id: delimitation.districtID,
                    name: delimitation.districtName,
                    constituencies: {
                        id: delimitation.constituencyID,
                        name: delimitation.constituencyName,
                    },
                });
            });
        }

        return {
            districts,
        };
    }
}

const authenticationService = new AuthenticationService();

export { authenticationService };